import { APICall } from "../../Helpers/Network/APICalls";
import { getMemberRegistrationStatusByMemberId, getUserDetails } from "../../Helpers/APIEndPoints/EndPoints";

const getParameter = (parameterName) => {
  let urlParameter = new URLSearchParams(window.location.search);
  return urlParameter.get(parameterName);
};

export const getUserData = () => {
  const id = getParameter("id");
  //  const id = 8;
  return async (dispatch) => {
    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    let token = getCookie("token");

    if (id !== null) {
      const response = await APICall(getUserDetails, {
        id,
      });

      dispatch({
        type: "getUserData",
        payload: response.Data,
      });
    }
  };
};

export const setEntityConfig = (payload) => {
  return {
    type: "setEntityConfig",
    payload,
  };
};

export const setUserRole = (payload) => {
  return {
    type: "setUserRole",
    payload,
  };
};

export const setUserData = (payload) => {
  return {
    type: "setUserData",
    payload,
  };
};

export const setSsoFromCurrentDomain = (payload) => {
  return {
    type: "setSsoFromCurrentDomain",
    payload,
  };
};

export const clearUserData = (payload) => {
  return {
    type: "clearUserData",
    payload,
  };
};

export const updateRole = (payLoads: any) => {
  return {
    type: "UPDATE_ROLE",
    payLoad: payLoads,
  };
};

// ==============
export const increment = (payLoads: any) => {
  return {
    type: "INCREMENT",
    payLoad: payLoads,
  };
};

export const decrement = (payLoads: any) => {
  return {
    type: "DECREMENT",
    payLoad: payLoads,
  };
};

//add user data
export const addUserData = (payload: any) => {
  return {
    type: "ADD_USER",
    payload: payload,
  };
};

//delete user data
export const deleteUserData = () => {
  return {
    type: "DELETE_USER",
  };
};

//call member status api
export const getMemberRegistrationStatusData = (memberId) => {
  return async (dispatch) => {
    if (memberId !== null) {
      const response = await APICall(getMemberRegistrationStatusByMemberId, {
        MemberId: memberId,
      });

      dispatch({
        type: "getMemberRegistrationStatusData",
        payload: response.Data,
      });
    }
  };
};
